import QuestionnaireDesignerService from 'src/modules/data-protection/apis/QuestionnaireDesignerService';
import { mapQuestions } from "src/modules/data-protection/helpers/questionnaire";
import { helpers } from "@smartintegrity/questionnaire";

export const fetchQuestionnaireQuestions = async (sectionId, softwareId) => {
    const service = QuestionnaireDesignerService.getInstance();

    const response = await service.fetchPrevAnswers(sectionId, {
        softwareId
    });

    const mappedQuestions = mapQuestions(response, response);

    return {
        mappedQuestions: helpers.makeQuestionsReadyForQuestionnaire(
            mappedQuestions,
            true
        ),
        rawQuestions: mappedQuestions,
        mappedAnswers: helpers.makePreviousAnswersReadyForQuestionnaire(
            mappedQuestions,
            mappedQuestions
        )
    };
};
